import React from 'react';
import { Tabs, Typography } from 'antd';
import { MoneyCollectOutlined } from '@ant-design/icons';
import ClientPayments from './ClientPayments';
import ClientChannels from './ClientChannels';

const { Title } = Typography;

export default function ClientHub() {
  return (
    <div>
      <Title level={3} style={{ marginTop: 0 }}>
        <MoneyCollectOutlined /> Client Channels & Payments
      </Title>
      <Tabs
        defaultActiveKey="channels"
        items={[
          { key: 'channels', label: 'Client Channels (Sheet-style)', children: <ClientChannels /> },
          { key: 'payments', label: 'Client Payments', children: <ClientPayments /> },
        ]}
      />
    </div>
  );
}
